export default __webpack_public_path__ + "static/media/921steak.fd1613ad.png";